<template>
  <section class="mar-footer">
    <footer class="footer-page">
      <b-row>
        <b-col order="4" order-sm="4" order-md="1" order-lg="1" order-xl="1" cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="content-logo">
            <a href="#home-mar">
              <b-img :src="require('../../assets/mar/img/Mar_Logotipo.svg')" fluid alt="Fluid image"></b-img>
            </a>
          </div>
        </b-col>
        <b-col order="1" order-sm="1" order-md="2" order-lg="2" order-xl="2" cols="12" sm="12" md="4"  lg="4" xl="3">
          <div class="footer-data">
            <span>VISÍTANOS</span>
            <p class="maps">
              WeWork Interlomas 
              <br><br>
              <a class="footer_hover footer_direction" href="https://www.google.com.mx/maps/place/WeWork+Centtral+Interlomas/@19.3927744,-99.282897,17z/data=!3m1!4b1!4m12!1m6!3m5!1s0x85d207ab854ce0d5:0x55c364b284251515!2sWeWork+Centtral+Interlomas!8m2!3d19.3927694!4d-99.2807083!3m4!1s0x85d207ab854ce0d5:0x55c364b284251515!8m2!3d19.3927694!4d-99.2807083" target="_blank">
                Blvd. Palmas Hills 1, <br> Valle de las Palmas, <br> 52763 Naucalpan de Juárez, Méx.
              </a>
            </p>
          </div>
        </b-col>
        <b-col class="row-cot" order="2" order-sm="2" order-md="3" order-lg="3" order-xl="3" cols="12" sm="12" md="4" lg="4" xl="3">
          <div class="footer-data">
            <span>OBTÉN UNA COTIZACIÓN</span>
            <p class="contact-styles">
              <a href="tel:5540397847" target="_blank" class="footer_hover">+55 4039 7847</a> 
              <br>
              <a href="mailto:hellomar@marabunta.work" class="footer_hover">hellomar@marabunta.work</a>
            </p>
          </div>
        </b-col>
        <b-col class="row-follow" order="3" order-sm="3" order-md="4" order-lg="4" order-xl="4" cols="12" sm="12" md="12" lg="12" xl="2">
          <div class="footer-data">
            <span>SÍGUENOS</span>
            <div class="icons">
              <a class="footer_hover icon_ins" href="https://www.instagram.com/marbymarabunta/?hl=es-la" target="_blank"><icon-base icon-name="Instagram"><icon-instagram /></icon-base></a>
              <a class="footer_hover" href="https://www.facebook.com/Mar-by-Marabunta-110420844079706" target="_blank"><icon-base icon-name="Facebook"><icon-facebook /></icon-base></a>
            </div>
          </div>
        </b-col>
        <b-col order="5" order-sm="5" order-md="5" order-lg="5" order-xl="5" cols="12" sm="12" md="4" lg="12" xl="2">
          <div class="content-copyright styles-copyright-2">
            <span>{{ $t("footer.copyright") }}</span>
            <br>
            <span class="footer_hover" onclick="window.open('https://marabunta.work/docs/Aviso_de_Privacidad.pdf','_blank')" style="cursor: pointer;">{{ $t("footer.privacy_notice") }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row class="row-copyright">
        <b-col cols="12">
          <div class="content-copyright styles-copyright-1">
            <span>© 2020. Todos los derechos reservados.</span>
            <span class="footer_hover" style="cursor: pointer;">Aviso de Privacidad</span>
          </div>
        </b-col>
      </b-row>
    </footer>
  </section>
</template>

<style>
.mar-footer .styles-copyright-1{
  text-align: right;
}
.mar-footer .row-copyright{
  margin-top: 100px;
}
@media (max-width: 1024px){
  .mar-footer .footer-page{
    padding-top: 40px;
    padding-bottom: 25px;
  }
  .mar-footer .row-copyright{
    margin-top: 30px;
  }
  .mar-footer .styles-copyright-1{
    text-align: right;
  }
  .mar-footer .content-logo img {
    width: 66%;
  }
  .mar-footer .footer-data span {
    letter-spacing: 0px;
  }
  .mar-footer .footer-data p {
    font-size: 16px;
    letter-spacing: 1.23px;
    line-height: 28px;
    margin-bottom: 0px;
  }
  .mar-footer .content-copyright span:first-child {
    font-size: 16px;
    letter-spacing: 1.23px;
    line-height: 28px;
  }
  .mar-footer .content-copyright span:last-child {
    font-size: 16px;
    letter-spacing: 1.23px;
    line-height: 28px;
  }
}
@media (max-width: 812px){
  .mar-footer .footer-page{
    padding-top: 40px;
    padding-bottom: 25px;
  }
  .mar-footer .row-copyright{
    margin-top: 10px;
  }
  .mar-footer .styles-copyright-1{
    text-align: left;
  }
  .mar-footer .content-logo img {
    width: 83%;
  }
  .mar-footer .footer-data span {
    letter-spacing: 0px;
  }
  .mar-footer .maps br:first-child{
    display: none;
  }
  .mar-footer .footer-data p {
    font-size: 12px;
    letter-spacing: 0.92px;
    line-height: 28px;
    margin-bottom: 0px;
  }
  .mar-footer .content-copyright span:first-child {
    font-size: 12px;
    letter-spacing: 0.92px;
    line-height: 28px;
  }
  .mar-footer .content-copyright span:last-child {
    font-size: 12px;
    letter-spacing: 0.92px;
    line-height: 28px;
  }
}
@media (max-width: 768px){
  .mar-footer .footer-page{
    padding-top: 40px;
    padding-bottom: 25px;
  }
  .mar-footer .row-copyright{
    margin-top: 30px;
  }
  .mar-footer .content-logo img {
    width: 88%;
  }
  .mar-footer .footer-data span {
    letter-spacing: 0px;
  }
  .mar-footer .maps br:first-child{
    display: none;
  }
  .mar-footer .footer-data p {
    font-size: 12px;
    letter-spacing: 0.92px;
    line-height: 28px;
    margin-bottom: 0px;
  }
  .mar-footer .content-copyright span:first-child {
    font-size: 12px;
    letter-spacing: 0.92px;
    line-height: 28px;
  }
  .mar-footer .content-copyright span:last-child {
    font-size: 12px;
    letter-spacing: 0.92px;
    line-height: 28px;
  }
  .mar-footer .styles-copyright-1{
    text-align: right;
  }
}
@media (max-width: 767px){
  .mar-footer .row-copyright{
    display: none;
  }
  .mar-footer .content-logo {
    margin: 50px 0px;
  }
  .mar-footer .content-logo img {
    width: 50%;
  }
  .mar-footer .maps br:first-child{
    display: none;
  }
  .mar-footer .row-cot, .mar-footer .row-follow {
    margin-top: 30px;
  }
}
@media (max-width: 450px){
  .mar-footer .content-logo img {
    width: 56%;
  }
}
</style>

<script>
import IconBase from './../IconBase'
import IconFacebook from './../icons/IconFacebook'
import IconInstagram from './../icons/IconInstagramV2'

export default {
  name: 'FooterMar',
  components: {
    IconBase,
    IconFacebook,
    IconInstagram
  }
}
</script>